import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import IcPrev from '../../assets/image/ic_arrow_left.svg';
import IcOption from '../../assets/image/report/ic_dots_btn.svg';
import OptionDialog from '../report/OptionDialog';

interface TopHeaderWithPrevOptionProps {
  title?: string;
  isMine?: boolean;
  selectedId?: number | null;
  onClickPrev?: () => void;
  reloadReport?: () => void;
  style?: React.CSSProperties;
  titleStyle?: React.CSSProperties | null;
  icon?: string | null;
}

export default function TopHeaderWithPrevOption({
  title = '',
  isMine = false,
  selectedId = null,
  onClickPrev = () => {},
  reloadReport = () => {},
  style = {},
  titleStyle = null,
  icon = null,
}: TopHeaderWithPrevOptionProps) {
  const [optionOpen, setOptionOpen] = useState(false);
  const navigate = useNavigate();

  const handleOptionClick = () => {
    setOptionOpen(true);
  };

  return (
    <div
      className="h-[48px] flex justify-center items-center w-full bg-white px-[20px] flex-grow-0 flex-shrink-0"
      style={{
        ...style,
      }}
    >
      <button type="button" className="w-[24px] h-[24px] cursor-pointer" onClick={onClickPrev}>
        <img src={icon ? icon : IcPrev} alt="back" />
      </button>
      <div
        className="text-[18px] leading-[19px] font-[700] text-[#2D2D2D] text-center flex-grow flex-shrink-1"
        style={titleStyle ? titleStyle : {}}
      >
        {title}
      </div>
      {isMine ? (
        <button
          type="button"
          className="w-[24px] h-[24px] cursor-pointer"
          onClick={handleOptionClick}
        >
          <img src={IcOption} alt="option" />
        </button>
      ) : (
        <div className="w-[24px] h-[24px]" style={{ visibility: 'hidden' }} />
      )}
      <OptionDialog
        open={optionOpen}
        onClose={() => setOptionOpen(false)}
        selectedId={selectedId}
        reload={() => {
          navigate(-1);
          reloadReport();
        }}
      />
    </div>
  );
}

